import { MouseEvent } from 'react'

interface MailtoOptions {
  body: string
  subject: string
}

type Platform = 'facebook' | 'twitter' | 'linkedin' | 'instagram' | 'link' | 'mailto'

export const useSocialShare = (mailto?: MailtoOptions) => {
  const getSharingUrl = (platform: Platform): string | undefined => {
    if (typeof window === 'undefined') return undefined

    const siteName = document.querySelector<HTMLMetaElement>(
      'meta[property="og:site_name"]',
    )?.content
    const pageUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]')?.content

    const {
      body = `Here is the url: ${pageUrl}`,
      subject = `I wanted to share an article on the ${siteName} website`,
    } = mailto || {}

    const url = encodeURIComponent(window.location.href)

    const urls: Record<Platform, string> = {
      facebook: `https://www.facebook.com/sharer.php?u=${url}`,
      instagram: `https://www.instagram.com`,
      link: url,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      mailto: `mailto:?subject=${subject}&body=${body}`,
      twitter: `https://twitter.com/intent/tweet?url=${url}`,
    }

    return urls[platform]
  }

  const openWindow = (url: string): void => {
    if (typeof window === 'undefined') return

    if (url?.includes('mailto:')) {
      window.location.href = url
      return
    }

    const size = 570
    const params = [
      'menubar=no',
      'toolbar=no',
      'status=no',
      `width=${size}`,
      `height=${size}`,
      `top=${(window.innerHeight - size) / 2}`,
      `left=${(window.innerWidth - size) / 2}`,
    ].join(',')

    window.open(url, 'NewWindow', params)
  }

  const copyLink = (url: string) => navigator.clipboard.writeText(decodeURIComponent(url))

  const handleClick = (
    event: MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLSpanElement | SVGElement>,
    platform: Platform,
  ) => {
    event.preventDefault()
    const url = getSharingUrl(platform)
    if (!url) return

    if (platform === 'link') {
      copyLink(url)
    } else {
      openWindow(url)
    }
  }

  return {
    getSharingUrl,
    handleClick,
    openWindow,
  }
}
